export default __webpack_public_path__ + "static/media/logo-pmce-min.66d0e2bf.png";